import EN from './EN';
import AR from './AR';

const translations = {
    EN,
    AR
};

const getTranslatedText = (
    key,
    locale
) => {
    const currTranslation = translations[locale] ? translations[locale] : AR;
    let translatedText  = currTranslation[key]
    ? currTranslation[key]
    : AR[key]
    ? AR[key]
    : key;

    return translatedText;
};

export { getTranslatedText };